import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlux = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 19.1663L12.0071 4.01562L21.9976 19.1663H20.137L12.0063 6.83029L4.89216 17.6024H14.9926L16.025 19.1663H2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.72656 15.8681L10.4539 13.2725L12.182 15.8681H8.72656ZM17.2014 19.1668L12.4786 11.9119H14.2925L19.0303 19.1668H17.2014ZM18.4512 11.6619L20.226 9.00391L22.0008 11.6619H18.4512Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgFlux);
export default ForwardRef;
